/**
 * @description Supported application regions
 */
export type AppRegion = 'au' | 'eu' | 'us'

export interface RegionOption {
  value: AppRegion
  label: string
}

export const APP_REGIONS: RegionOption[] = [
  { value: 'au', label: 'Asia Pacific' },
  { value: 'eu', label: 'Europe' },
  { value: 'us', label: 'North America' },
]

/**
 * Checks if the provided value is a valid region
 */
export function isValidRegion(value: string): value is AppRegion {
  return value === 'au' || value === 'eu' || value === 'us'
}
